<template>
    <div>
        <h1 class="title has-text-centered">Fiche de présentation</h1>

        <b-field label="Présentation succincte du site ou du territoire concerné et de la nature de l'implication du CEN">
            <b-input maxlength="1500"
                     type="textarea"
                     v-model="p1"
                     @blur="autoSave">
            </b-input>
        </b-field>

        <b-field label="Présentation du projet">
            <b-input
                    maxlength="2000"
                    type="textarea"
                    v-model="p2"
                    @blur="autoSave">
            </b-input>
        </b-field>
    </div>
</template>

<script>
    export default {
        name: "Finalisation",
        data() {
            return {

                p1: '',
                p2: '',
            }
        },
        mounted() {
            if (localStorage.getItem("p1")) {
                this.p1 = JSON.parse(localStorage.getItem("p1"));
            } else {
                this.p1 = '';
            }
            if (localStorage.getItem("p2")) {
                this.p2 = JSON.parse(localStorage.getItem("p2"));
            } else {
                this.p2 = '';
            }
        },
        methods: {
            autoSave() {
                localStorage.setItem("p1", JSON.stringify(this.p1));
                localStorage.setItem("p2", JSON.stringify(this.p2));
                this.p1 = JSON.parse(localStorage.getItem("p1"));
                this.p2 = JSON.parse(localStorage.getItem("p2"));
            }
        },
    }
</script>

<style scoped>

</style>
